import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { PipesModule } from "src/app/_pipes/pipes.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { QRCodeModule } from "angularx-qrcode";
import { IonicModule } from "@ionic/angular";

import { EditInvitationPageRoutingModule } from "./edit-invitation-routing.module";

import { EditInvitationPage } from "./edit-invitation.page";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { ApiNotFoundComponentModule } from "../../_component/api-not-found/api-not-found.component.module";
import { AvatarComponentModule } from "../../_component/avatar/avatar.module";
import { AddInvitationSpaceViewComponentModule } from "../add-invitation/add-invitation-space-view/add-invitation-space-view.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EditInvitationPageRoutingModule,
    TranslateModule,
    QRCodeModule,
    PaginationClientSideModule,
    HeaderModule,
    SelectDropdownModule,
    LoadingStiModule,
    SharedDirectivesModule,
    PipesModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    AvatarComponentModule,
    AddInvitationSpaceViewComponentModule,
  ],
  declarations: [EditInvitationPage],
})
export class EditInvitationPageModule {}
